import { Directive, ElementRef, EventEmitter, Inject, OnDestroy, OnInit, Output, Renderer2 } from '@angular/core'

@Directive({
    selector: '[stopEvent]',
    standalone: false
})
export class StopEventDirective implements OnInit, OnDestroy {
    @Output('stopEvent') handler = new EventEmitter<Event>()

    private unsubscriber: any

    constructor(@Inject(Renderer2) private renderer: Renderer2,
                @Inject(ElementRef )private element: ElementRef) { }

    ngOnInit() {
        this.unsubscriber = this.renderer.listen(this.element.nativeElement, 'click', event => {
            event.stopPropagation()
            this.handler.emit(event)
        })
    }

    ngOnDestroy() {
        this.unsubscriber?.()
    }
}
